module.exports = __webpack_public_path__ + "static/media/sword-laser-alt.788495f7.svg";